<!-- SCREENING ASSETS component -->
<template>
  <md-card id="screeningassets" class="md-with-hover">
    <!--
    <md-card-header class="md-card-header-icon md-card-header-green">
      <div class="card-icon"><md-icon>list_alt</md-icon></div>
      <h4 class="title">Medical History</h4>
    </md-card-header>
     -->
    <!--<span style="20px; margin-left: 15px; font-size: .8rem; font-weight: 400; color: green">Hisorical Information</span>-->
    <md-card-content style="padding: 0px 0px 0px 0px; margin-top: 20px">
      <div class="md-layout">
        <div class="md-layout-item md-size-33" align="Center">
          <label class="md-caption" style="font-size: 0.8rem; font-weight: 400; color: green"
            >Historical Information</label
          >
          <hr />

          <div>
            <div class="md-layout md-layout-nowrap">
              <span class="md-layout-item md-size-30 history-label" align="Left">Chief Complaint:</span>
              <span class="md-layout-item history-value" align="Left">{{ patientInfo.chiefComplaint }}</span>
            </div>
            <div class="md-layout md-layout-nowrap">
              <span class="md-layout-item md-size-30 history-label" align="Left">Issues:</span>
              <span class="md-layout-item history-value" align="Left">{{ patientInfo.issues }}</span>
            </div>
            <div class="md-layout md-layout-nowrap">
              <span class="md-layout-item md-size-30 history-label" align="Left">Eye Surgery:</span>
              <span class="md-layout-item history-value" align="Left">{{ medicalInfo.histSurgery }}</span>
            </div>
            <div class="md-layout md-layout-nowrap">
              <span class="md-layout-item md-size-30 history-label" align="Left">Cancer:</span>
              <span class="md-layout-item history-value" align="Left">{{ medicalInfo.histCancer }}</span>
            </div>
            <div class="md-layout md-layout-nowrap">
              <span class="md-layout-item md-size-30 history-label" align="Left">Diabetes:</span>
              <span class="md-layout-item history-value" align="Left">{{ medicalInfo.histDiabetes }}</span>
            </div>
            <div class="md-layout md-layout-nowrap">
              <span class="md-layout-item md-size-30 history-label" align="Left">Personal Other:</span>
              <span class="md-layout-item history-value" align="Left">{{ medicalInfo.histOther }}</span>
            </div>
            <div class="md-layout md-layout-nowrap">
              <span class="md-layout-item md-size-30 history-label" align="Left">Family Other:</span>
              <span class="md-layout-item history-value" align="Left">{{ medicalInfo.famOther }}</span>
            </div>
          </div>
        </div>

        <div class="md-layout-item md-size-33" align="center">
          <label class="md-caption" style="font-size: 0.8rem; font-weight: 400; color: green">Medical History</label>
          <hr />

          <div class="md-layout" align="Left">
            <div
              class="md-layout-item md-size50"
              align="Left"
              style="padding: 0px 5px 0px 5px; min-width: 112px; max-width: 170px"
            >
              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="mHyp" :value="chk_mHyp" :disabled="disAble_mHyp" class="sasset"
                  >Hypertension</md-radio
                >
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="mStr" :value="chk_mStr" :disabled="disAble_mStr" class="sasset">Stroke</md-radio>
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="mLiv" :value="chk_mLiv" :disabled="disAble_mLiv" class="sasset"
                  >Liver Disease</md-radio
                >
              </div>
            </div>

            <div
              class="md-layout md-layout-item md-size50"
              style="padding: 0px 5px 0px 5px; min-width: 112px; max-width: 150px"
            >
              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="mCho" :value="chk_mCho" :disabled="disAble_mCho" class="sasset"
                  >Cholesterol</md-radio
                >
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0">
                <md-radio v-model="mMig" :value="chk_mMig" :disabled="disAble_mMig" class="sasset">Migraines</md-radio>
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="mHrt" :value="chk_mHrt" :disabled="disAble_mHrt" class="sasset"
                  >Heart Disease</md-radio
                >
              </div>
            </div>
          </div>
        </div>

        <div class="md-layout-item md-size-33" align="center" style="padding-bottom: 30px">
          <label class="md-caption" style="font-size: 0.8rem; font-weight: 400; color: green">Family History</label>
          <hr />

          <div class="md-layout" align="Left">
            <div
              class="md-layout-item md-size-45"
              align="Left"
              style="padding: 0px 5px 0px 5px; min-width: 107px; max-width: 170px"
            >
              <div
                class="md-layout-item"
                style="height: 15px; margin: 0px; padding: 0px; font-size: 0.7rem; color: green"
              >
                Ocular:
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fGla" :value="chk_fGla" :disabled="disAble_fGla" class="sasset">Glaucoma</md-radio>
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fMac" :value="chk_fMac" :disabled="disAble_fMac" class="sasset"
                  >Macular Degeneration</md-radio
                >
              </div>
            </div>

            <div
              class="md-layout md-layout-item md-size-55"
              align="Left"
              style="padding: 0px 5px 0px 5px; min-width: 135px; max-width: 158px"
            >
              <div
                class="md-layout-item"
                style="height: 15px; margin: 0px 35px 0px 0px; padding: 0px; font-size: 0.7rem; color: green"
              >
                Systemic:
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fCan" :value="chk_fCan" :disabled="disAble_fCan" class="sasset">Cancer</md-radio>
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fDia" :value="chk_fDia" :disabled="disAble_fDia" class="sasset">Diabetes</md-radio>
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fMig" :value="chk_fMig" :disabled="disAble_fMig" class="sasset">Migraines</md-radio>
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fStroke" :value="chk_fStroke" :disabled="disAble_fStroke" class="sasset"
                  >Stroke</md-radio
                >
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fCho" :value="chk_fCho" :disabled="disAble_fCho" class="sasset"
                  >Cholesterol
                </md-radio>
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fLiv" :value="chk_fLiv" :disabled="disAble_fLiv" class="sasset"
                  >Liver Disease</md-radio
                >
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fHrt" :value="chk_fHrt" :disabled="disAble_fHrt" class="sasset"
                  >Heart Disease</md-radio
                >
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio
                  v-model="fBloodPressure"
                  :value="chk_fBloodPressure"
                  :disabled="disAble_fBloodPressure"
                  class="sasset blood-pressure"
                  >High Blood Pressure</md-radio
                >
              </div>

              <div class="md-layout-item" style="height: 25px; padding: 0 0 0 0" align="Left">
                <md-radio v-model="fAlz" :value="chk_fAlz" :disabled="disAble_fAlz" class="sasset"
                  >Alzheimer's</md-radio
                >
              </div>
            </div>
          </div>
        </div>

        <div class="md-layout-item md-size-50" align="center" style="padding-bottom: 30px">
          <label class="md-caption" style="font-size: 0.8rem; font-weight: 400; color: green">Glasses History</label>
          <hr />
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <span> OD </span>
              <screening-eye-history eye="od" type="glasses" />
            </div>
            <div class="md-layout-item md-size-50">
              <span class="md-layout-item md-size-100"> OS </span>
              <screening-eye-history eye="os" type="glasses" />
            </div>
          </div>
        </div>

        <div class="md-layout-item md-size-50" align="center" style="padding-bottom: 30px">
          <label class="md-caption" style="font-size: 0.8rem; font-weight: 400; color: green">Contacts History</label>
          <hr />
          <div class="md-layout md-layout-item">
            <div class="md-layout-item md-size-50">
              <span class="md-layout-item md-size-100"> OD </span>
              <screening-eye-history eye="od" type="contacts" />
            </div>
            <div class="md-layout-item md-size-50">
              <span class="md-layout-item md-size-100"> OS </span>
              <screening-eye-history eye="os" type="contacts" />
            </div>
          </div>
        </div>

        <!--ASSETS INFO-->
        <hr style="width: 100%" />
        <screening-assets-info />
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import InfoScreeningAssets from "@/components/GlobeChek/screening/info-screening-assets"
import infoScreeningEyeHistory from "./info-screening-eye-history.vue"
import { mapGetters } from "vuex"
export default {
  name: "InfoScreeningAssets",
  components: {
    "screening-assets-info": InfoScreeningAssets,
    "screening-eye-history": infoScreeningEyeHistory
  },
  data() {
    return {
      mHyp: null,
      disAble_mHyp: true,
      mStr: null,
      disAble_mStr: true,
      mLiv: null,
      disAble_mLiv: true,
      mCho: null,
      disAble_mCho: true,
      mMig: null,
      disAble_mMig: true,
      mHrt: null,
      disAble_mHrt: true,

      fDia: null,
      disAble_fDia: true,
      fGla: null,
      disAble_fGla: true,
      fAlz: null,
      disAble_fAlz: true,
      fLiv: null,
      disAble_fLiv: true,
      fCan: null,
      disAble_fCan: true,
      fCho: null,
      disAble_fCho: true,
      fMig: null,
      disAble_fMig: true,
      fHrt: null,
      disAble_fHrt: true,
      fMac: null,
      disAble_fMac: true,
      fBloodPressure: null,
      disAble_fBloodPressure: true,
      fStroke: null,
      disAble_fStroke: true
    }
  },

  computed: {
    ...mapGetters(["screeningAssets", "medicalInfo", "patientInfo"]),

    // HISTORY VALUES
    chk_mHyp: {
      get: function () {
        if (this.medicalInfo.histPressure == "true") {
          this.mHyp = true
          this.disAble_mHyp = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_mStr: {
      get: function () {
        if (this.medicalInfo.histStroke == "true") {
          this.mStr = true
          this.disAble_mStr = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_mLiv: {
      get: function () {
        if (this.medicalInfo.histLiver == "true") {
          this.mLiv = true
          this.disAble_mLiv = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_mCho: {
      get: function () {
        if (this.medicalInfo.histCholesterol == "true") {
          this.mCho = true
          this.disAble_mCho = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_mMig: {
      get: function () {
        if (this.medicalInfo.histMigraines == "true") {
          this.mMig = true
          this.disAble_mMig = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_mHrt: {
      get: function () {
        if (this.medicalInfo.histHeart == "true") {
          this.mHrt = true
          this.disAble_mHrt = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },

    // FAMILY VALUES
    chk_fDia: {
      get: function () {
        if (this.medicalInfo.famDiabetes == "true") {
          this.fDia = true
          this.disAble_fDia = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fGla: {
      get: function () {
        if (this.medicalInfo.famGlaucoma == "true") {
          this.fGla = true
          this.disAble_fGla = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fAlz: {
      get: function () {
        if (this.medicalInfo.famAlzheimers == "true") {
          this.fAlz = true
          this.disAble_fAlz = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fCho: {
      get: function () {
        if (this.medicalInfo.famCholesterol == "true") {
          this.fCho = true
          this.disAble_fCho = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fMig: {
      get: function () {
        if (this.medicalInfo.famMigraines == "true") {
          this.fMig = true
          this.disAble_fMig = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fHrt: {
      get: function () {
        if (this.medicalInfo.famHeart == "true") {
          this.fHrt = true
          this.disAble_fHrt = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fMac: {
      get: function () {
        if (this.medicalInfo.famMacDegen == "true") {
          this.fMac = true
          this.disAble_fMac = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fBloodPressure: {
      get: function () {
        if (this.medicalInfo.famPressure == "true") {
          this.fBloodPressure = true
          this.disAble_fBloodPressure = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fStroke: {
      get: function () {
        if (this.medicalInfo.famStroke == "true") {
          this.fStroke = true
          this.disAble_fStroke = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fLiv: {
      get: function () {
        if (this.medicalInfo.famLiver == "true") {
          this.fLiv = true
          this.disAble_fLiv = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    chk_fCan: {
      get: function () {
        if (this.medicalInfo.famCancer == "true") {
          this.fCan = true
          this.disAble_fCan = false
          return true
        }
      },
      set: function (val) {
        return
      }
    },
    getChiefComplaint() {
      return !this.patientInfo.chiefComplaint ? "-" : this.patientInfo.chiefComplaint
    },
    getIssues() {
      return !this.patientInfo.issues ? "-" : this.patientInfo.issues
    },
  },

  mounted: function () {
    //this.clearValues();
    this.$forceUpdate()
    //console.log('MedInfo:',this.medicalInfo);
  },
  methods: {
    clearValues() {
      //Clear Medical
      this.chk_mHyp = this.chk_mStr = this.chk_mLiv = this.chk_mCho = this.chk_mMig = this.chk_mHrt = false
      this.mHyp = this.mStr = this.mLiv = this.mCho = this.mMig = this.mHrt = null
      this.disAble_mHyp =
        this.disAble_mStr =
        this.disAble_mLiv =
        this.disAble_mCho =
        this.disAble_mMig =
        this.disAble_mHrt =
        true

      // Clear Family
      this.chk_fDia = this.chk_fGla = this.chk_fAlz = this.chk_fLiv = this.chk_fCan = false
      this.chk_fCho = this.chk_fMig = this.chk_fHrt = this.chk_fMac = false
      this.fDia = this.fGla = this.fAlz = this.fLiv = this.fCan = null
      this.fCho = this.fMig = this.fHrt = this.fMac = null
      this.disAble_fDia = this.disAble_fGla = this.disAble_fAlz = this.disAble_fLiv = this.disAble_fCan = true
      this.disAble_fCho = this.disAble_fMig = this.disAble_fHrt = this.disAble_fMac = true
    }
  }
}
</script>

<style lang="scss" scoped>
input[type="radio"][disabled] {
  outline: 1px solid red !important;
  font-size: 2rem;
}
#screeningassets {
  width: 97.5%;
  display: inline-block;
  vertical-align: top;
}
.label {
  font-size: 0.7rem;
  //font-weight: 500;
}
.field {
  font-size: 0.95rem;
  font-weight: 400;
  color: rgb(0, 0, 139);
}
.md-chekbox {
  padding: 0px;
  margin: 0px;
}
.sasset {
  padding-left: 5px !important;
  color: rgb(0, 0, 0);
  font-size: 0.8rem;
  line-height: 20px;
}
.sasset.blood-pressure ::v-deep .md-radio-label {
  line-height: 10px;
}
.md-radio .md-radio-label {
  padding-left: 5px !important;
  color: rgb(0, 0, 0) !important;
}

.history-label {
  padding: 0px 5px 0px 7px;
  margin-right: 4px;
  min-width: 15ch;
  height: 25px;
  font-size: 0.72rem;
  white-space: nowrap;
}

.history-value {
  padding: 0px 0px 0px 0px;
  font-size: 0.77rem;
  color: darkblue;
}
</style>
